require('jquery-ui-bundle')
require('jquery.fancybox')
require('jquery-ujs')
require('../../../node_modules/jquery.fancybox/source/jquery.fancybox.css')

require('javascripts/phrasing')

var css = require.context("stylesheets")
css.keys().forEach(css)

var img = require.context("images")
img.keys().forEach(img)

var componentRequireContext = require.context("components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

$(document).ready(function(){

  $(".page_gallery a").fancybox();

  $("#search_icon").on("click", function(){
    $("#search_icon form").fadeToggle(300);
    setTimeout(function(){ $("#search_icon form input").focus() }, 310);
  })

  $(document).on("click", "#load_older_news_button", function(e){
    e.preventDefault();
    $(this).text("... učitavam ...");
    var button = $(this)
    $.ajax({url: this.href, success: function(result){
      button.hide()
      $(".news_container section").append(result);
    }})
  })

})



// WEBPACK FOOTER //
// app/frontend/packs/application.js